/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as VerifyImport } from './routes/verify'
import { Route as VaultImport } from './routes/vault'
import { Route as UserProfileImport } from './routes/user-profile'
import { Route as SendTransactionImport } from './routes/send-transaction'
import { Route as RankingImport } from './routes/ranking'
import { Route as NotFoundImport } from './routes/not-found'
import { Route as LandingPageImport } from './routes/landing-page'
import { Route as EditProfileImport } from './routes/edit-profile'
import { Route as IndexImport } from './routes/index'

// Create/Update Routes

const VerifyRoute = VerifyImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRoute,
} as any)

const VaultRoute = VaultImport.update({
  id: '/vault',
  path: '/vault',
  getParentRoute: () => rootRoute,
} as any)

const UserProfileRoute = UserProfileImport.update({
  id: '/user-profile',
  path: '/user-profile',
  getParentRoute: () => rootRoute,
} as any)

const SendTransactionRoute = SendTransactionImport.update({
  id: '/send-transaction',
  path: '/send-transaction',
  getParentRoute: () => rootRoute,
} as any)

const RankingRoute = RankingImport.update({
  id: '/ranking',
  path: '/ranking',
  getParentRoute: () => rootRoute,
} as any)

const NotFoundRoute = NotFoundImport.update({
  id: '/not-found',
  path: '/not-found',
  getParentRoute: () => rootRoute,
} as any)

const LandingPageRoute = LandingPageImport.update({
  id: '/landing-page',
  path: '/landing-page',
  getParentRoute: () => rootRoute,
} as any)

const EditProfileRoute = EditProfileImport.update({
  id: '/edit-profile',
  path: '/edit-profile',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/edit-profile': {
      id: '/edit-profile'
      path: '/edit-profile'
      fullPath: '/edit-profile'
      preLoaderRoute: typeof EditProfileImport
      parentRoute: typeof rootRoute
    }
    '/landing-page': {
      id: '/landing-page'
      path: '/landing-page'
      fullPath: '/landing-page'
      preLoaderRoute: typeof LandingPageImport
      parentRoute: typeof rootRoute
    }
    '/not-found': {
      id: '/not-found'
      path: '/not-found'
      fullPath: '/not-found'
      preLoaderRoute: typeof NotFoundImport
      parentRoute: typeof rootRoute
    }
    '/ranking': {
      id: '/ranking'
      path: '/ranking'
      fullPath: '/ranking'
      preLoaderRoute: typeof RankingImport
      parentRoute: typeof rootRoute
    }
    '/send-transaction': {
      id: '/send-transaction'
      path: '/send-transaction'
      fullPath: '/send-transaction'
      preLoaderRoute: typeof SendTransactionImport
      parentRoute: typeof rootRoute
    }
    '/user-profile': {
      id: '/user-profile'
      path: '/user-profile'
      fullPath: '/user-profile'
      preLoaderRoute: typeof UserProfileImport
      parentRoute: typeof rootRoute
    }
    '/vault': {
      id: '/vault'
      path: '/vault'
      fullPath: '/vault'
      preLoaderRoute: typeof VaultImport
      parentRoute: typeof rootRoute
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyImport
      parentRoute: typeof rootRoute
    }
  }
}

// Create and export the route tree

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/edit-profile': typeof EditProfileRoute
  '/landing-page': typeof LandingPageRoute
  '/not-found': typeof NotFoundRoute
  '/ranking': typeof RankingRoute
  '/send-transaction': typeof SendTransactionRoute
  '/user-profile': typeof UserProfileRoute
  '/vault': typeof VaultRoute
  '/verify': typeof VerifyRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/edit-profile': typeof EditProfileRoute
  '/landing-page': typeof LandingPageRoute
  '/not-found': typeof NotFoundRoute
  '/ranking': typeof RankingRoute
  '/send-transaction': typeof SendTransactionRoute
  '/user-profile': typeof UserProfileRoute
  '/vault': typeof VaultRoute
  '/verify': typeof VerifyRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/edit-profile': typeof EditProfileRoute
  '/landing-page': typeof LandingPageRoute
  '/not-found': typeof NotFoundRoute
  '/ranking': typeof RankingRoute
  '/send-transaction': typeof SendTransactionRoute
  '/user-profile': typeof UserProfileRoute
  '/vault': typeof VaultRoute
  '/verify': typeof VerifyRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/edit-profile'
    | '/landing-page'
    | '/not-found'
    | '/ranking'
    | '/send-transaction'
    | '/user-profile'
    | '/vault'
    | '/verify'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/edit-profile'
    | '/landing-page'
    | '/not-found'
    | '/ranking'
    | '/send-transaction'
    | '/user-profile'
    | '/vault'
    | '/verify'
  id:
    | '__root__'
    | '/'
    | '/edit-profile'
    | '/landing-page'
    | '/not-found'
    | '/ranking'
    | '/send-transaction'
    | '/user-profile'
    | '/vault'
    | '/verify'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  EditProfileRoute: typeof EditProfileRoute
  LandingPageRoute: typeof LandingPageRoute
  NotFoundRoute: typeof NotFoundRoute
  RankingRoute: typeof RankingRoute
  SendTransactionRoute: typeof SendTransactionRoute
  UserProfileRoute: typeof UserProfileRoute
  VaultRoute: typeof VaultRoute
  VerifyRoute: typeof VerifyRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  EditProfileRoute: EditProfileRoute,
  LandingPageRoute: LandingPageRoute,
  NotFoundRoute: NotFoundRoute,
  RankingRoute: RankingRoute,
  SendTransactionRoute: SendTransactionRoute,
  UserProfileRoute: UserProfileRoute,
  VaultRoute: VaultRoute,
  VerifyRoute: VerifyRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/edit-profile",
        "/landing-page",
        "/not-found",
        "/ranking",
        "/send-transaction",
        "/user-profile",
        "/vault",
        "/verify"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/edit-profile": {
      "filePath": "edit-profile.tsx"
    },
    "/landing-page": {
      "filePath": "landing-page.tsx"
    },
    "/not-found": {
      "filePath": "not-found.tsx"
    },
    "/ranking": {
      "filePath": "ranking.tsx"
    },
    "/send-transaction": {
      "filePath": "send-transaction.tsx"
    },
    "/user-profile": {
      "filePath": "user-profile.tsx"
    },
    "/vault": {
      "filePath": "vault.tsx"
    },
    "/verify": {
      "filePath": "verify.tsx"
    }
  }
}
ROUTE_MANIFEST_END */
